import { Injectable } from '@angular/core';
import produce from 'immer';

import { GetPotentialDuplicatesGQL, GetPotentialDuplicatesQuery } from 'generated/graphql';
import { map } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class EntityDuplicateFinderService {


  constructor(
    private _getDuplicatesGQL: GetPotentialDuplicatesGQL
  ) {
  }

  public async initEntityDuplicateEntry(entityId: string, campaignId: string) {
    const data = await lastValueFrom(this.getPotentialDuplicates(entityId, campaignId));
    const entry = new EntityDuplicateEntry(entityId, campaignId, data);
    return entry;
  }
  /**
   * Fetches potential duplicates for an entity
   */
  getPotentialDuplicates(entityId: string, campaignId: string) {
    return this._getDuplicatesGQL.fetch({
      entityId, campaignId
    }).pipe(
      map(result => result.data.getPotentialEntityDuplicates)
    );
  }
}

export class EntityDuplicateEntry {
  constructor(
    public entityId: string,
    public campaignId: string,
    public duplicateData: GetPotentialDuplicatesQuery['getPotentialEntityDuplicates']
  ) {
  }

  phoneMatches(phoneNumber: string, ext: string = null) {
    const phoneKey = [phoneNumber,',',ext].filter(v => !!v).join('');
    const matches = (this.duplicateData.phoneMatches.find(pm => pm.key === phoneKey) || { entities: [] }).entities;
    return matches;
  }

   emailMatches(email: string) {
    const matches = (this.duplicateData.emailMatches.find(pm => pm.key === email) || { entities: [] }).entities;
    return matches;
  }

}
